import {
  Button,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { isArray } from "lodash";
import { useMemo, useState } from "react";
import DatePickers from "./components/DatePickers";
import FilterInput from "./components/FilterInput";

export default function AdminFilterBox({ inputs, submitFunction, sx = {} }) {
  const [open, setOpen] = useState(false);
  const hasDates = useMemo(()=>inputs.filter((i) => i.type !== "text").length,[inputs]);
  if (!isArray(inputs)) {
    return null;
  }
  return (
    <Grid container sx={sx}>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<FilterListIcon />}
          endIcon={
            <ExpandMoreIcon
              sx={{
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
              }}
            />
          }
          onClick={() => setOpen((prev) => !prev)}
        >
          Filters
        </Button>
      </Grid>
      <Collapse in={open} sx={{ width: "100%" }}>
        <Grid container>
          <Grid
            item
            xs={hasDates ? 6 : 12}
            justifyContent={"flex-start"}
            gap={4}
            spacing={2}
          >
            {inputs
              .filter((i) => i.type === "text")
              .map((item) => {
                return (
                  <FilterInput
                    filterName={item.name}
                    state={item.state}
                    setState={item.setState}
                    onUpdateFunction={item.function}
                  />
                );
              })}
          </Grid>
          {hasDates ? (
            <Grid item xs={6} spacing={4}>
              {inputs
                .filter((item) => item.type === "dropdown")
                .map((item) => {
                  return (
                    <FormControl fullWidth sx={{ margin: "10px 5px " }}>
                      <InputLabel id="Filter">Type</InputLabel>
                      <Select
                        labelId={item.label}
                        id={item.label}
                        label={item.label}
                        defaultValue={item.defaultValue}
                        onChange={(e) => {
                          item.setState(e.target.value);
                        }}
                      >
                        {item.items.map((i) => (
                          <MenuItem value={i.value}>{i.value_label}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  );
                })}
              {inputs
                .filter((item) => item.type === "date")
                .map((item) => {
                  return (
                    <DatePickers
                      state={item.dateStart}
                      setState={item.setDateStart}
                      secondState={item.dateEnd}
                      setSecondState={item.setDateEnd}
                      onUpdateFunction={item.function}
                    />
                  );
                })}
            </Grid>
          ) : null}
          <Grid item xs={12} sx={{ my: 1 }}>
            {submitFunction ? (
              <Button
                fullWidth
                variant={"contained"}
                color="primary"
                onClick={submitFunction}
              >
                Search
              </Button>
            ) : null}
          </Grid>
        </Grid>
      </Collapse>
    </Grid>
  );
}
